import type { TOC } from '@ember/component/template-only';
import safeFormatDate from '../../../helpers/safe-format-date.ts';

export interface ItemDetailsSignature {
  Args: {
    details?: string;
    date?: string;
  };
  Element: HTMLDivElement;
}

const ItemDetails: TOC<ItemDetailsSignature> = <template>
  {{#if @details}}
    <div class="tio-row-between w-full ml-2 mb-2 text-tio-gray-400" ...attributes>
      <p class="py-0.5 text-sm leading-5 text-tio-gray-700 mr-2 flex-wrap">
        {{@details}}
      </p>
      <div
        class="flex flex-wrap justify-end md:flex-nowrap md:whitespace-nowrap order-1 md:order-none md:divide-x md:divide-gray-400 dark:md:divide-gray-500"
      >
        <time datetime={{@date}} class="py-0.5 px-2 text-xs leading-5 text-tio-gray-400">
          {{safeFormatDate @date hour="numeric" minute="2-digit" timeZoneName="short"}}
        </time>
        <time datetime={{@date}} class="py-0.5 px-2 text-sm leading-5 text-tio-gray-600">
          {{safeFormatDate @date month="short" day="2-digit" year="numeric"}}
        </time>
      </div>
    </div>
  {{/if}}
</template>;

export default ItemDetails;
